import { createSlice } from '@reduxjs/toolkit';

export interface ReportsState {
    fetching: string;
    generalReport: any;
    dealershipReport: any;
}

const initialState: ReportsState = {
    fetching: "",
    generalReport: null,
    dealershipReport: null
};

const reportsSlice = createSlice({
    name: 'reports',
    initialState,
    reducers: {
        getReportsRequest: (state, action) => {
            state.fetching = action.payload;
        },
        getReportsSuccess: (state, action) => {
            state.fetching = "";
            if (action.payload.type === 'general') {
                state.generalReport = action.payload.data;
            } else if (action.payload.type === 'dealership') {
                state.dealershipReport = action.payload.data;
            }
        },
        getReportsFailure: (state) => {
            state.fetching = "failure";
        },
        cleanReports: (state) => {
            state.generalReport = null;
            state.dealershipReport = null;
            state.fetching = "";
        }
    }
});

export const {
    getReportsRequest,
    getReportsSuccess,
    getReportsFailure,
    cleanReports
} = reportsSlice.actions;

export default reportsSlice.reducer;
